export const agentsUserSubMenu = [{
  path: '/agents-users/list/:agentId(\\d+)',
  component: () => import('@/views/agents-users/list.vue'),
  name: 'dealerManagement.agentsUser.title',
  meta: {
    title: 'dealerManagement.agentsUser.title',
    icon: 'user',
    noCache: true,
    hidden: true
  }
}, {
  path: '/agents-users/add/:agentId(\\d+)',
  component: () => import('@/views/agents-users/manage.vue'),
  name: 'dealerManagement.agentsUsers.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'dealerManagement.agentsUser.add',
    noCache: true,
    activeMenu: '/agents-users/list/:agentId(\\d+)',
    hidden: true
  }
}, {
  path: '/agents-users/edit/:id(\\d+)',
  component: () => import('@/views/agents-users/manage.vue'),
  name: 'dealerManagement.agentsUser.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'dealerManagement.agentsUser.edit',
    noCache: true,
    activeMenu: '/agents-users/list/:agentId(\\d+)',
    hidden: true
  }
}];